import moment from 'moment-timezone';
import { ActionResponse } from '../../utils/typing';
import Reclamation from '../reclamations/models';

const from = sessionStorage.getItem('rewashesFrom');
const until = sessionStorage.getItem('rewashesUntil');
const tz: string = sessionStorage.getItem('timeZone') || 'UTC';

interface RewashState {
  rewashes: Reclamation[];
  rewashInEdit: Reclamation | null;
  fromDate: string;
  untilDate: string;
}

export const initialState = {
  rewashes: [],
  rewashInEdit: null,
  fromDate: from || moment.tz(tz).subtract(9, 'days').toISOString(),
  untilDate: until || moment.tz(tz).toISOString(),
};

const getRewashesSuccess = (state: RewashState, action: ActionResponse) => {
  if (!action) {
    return {
      ...state,
      rewashes: [],
    };
  }
  const rewashes = action.results.map((i: Reclamation) => new Reclamation(i));
  return {
    ...state,
    rewashes,
  };
};

const setFromDate = (state: RewashState, date: string | moment.Moment) => {
  let formattedDate = '';
  if (typeof date !== 'string') {
    formattedDate = date.format('YYYY-MM-DD');
    window.sessionStorage.setItem('rewashesFrom', formattedDate);
  }
  return { ...state, fromDate: formattedDate };
};

const setUntilDate = (state: RewashState, date: string | moment.Moment) => {
  let formattedDate = '';
  if (typeof date !== 'string') {
    formattedDate = date.format('YYYY-MM-DD');
    window.sessionStorage.setItem('rewashesUntil', formattedDate);
  }

  return { ...state, untilDate: formattedDate };
};

export const rewashes = (state = initialState, action: ActionResponse): RewashState => {
  switch (action.type) {
    case 'FETCH_REWASHES_SUCCESS':
      return getRewashesSuccess(state, action.response);
    case 'SET_REWASH_FROM_DATE':
      return setFromDate(state, action.payload);
    case 'SET_REWASH_UNTIL_DATE':
      return setUntilDate(state, action.payload);
    default:
      return state;
  }
};

export const selectRewashes = (state: { rewashes: RewashState }) => state?.rewashes?.rewashes;
export const selectFromDate = (state: { rewashes: RewashState }) => state?.rewashes?.fromDate;
export const selectUntilDate = (state: { rewashes: RewashState }) => state?.rewashes?.untilDate;
export const selectRewashInEdit = (state: { rewashes: RewashState }) =>
  state?.rewashes?.rewashInEdit;
